module.exports = __webpack_public_path__ + "media/images/img_mansion_selling_1-3baa8c6541a5b49037886149cf929c22.png";